module.exports = __webpack_public_path__ + "static/img/service_banana04.0b3437f.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/service_banana04.png
// module id = Sdni
// module chunks = 0